import React from 'react';
import { MusicTier } from '../../api/payment/music-request.api';
import { tierChoiceLabel } from '../../utils/music-request';

const HINT = 'Bài ngắn hơn thời lượng đã chọn sẽ được phát hết bài.';

/**
 * Người xem chọn mức giá và thời lượng phát. Khai ở mức module (không khai trong render) để
 * không bị dựng lại mỗi lần cha render.
 */
const MusicTierPicker: React.FC<{
  tiers: MusicTier[];
  selectedPrice: number | null;
  onSelect: (price: number) => void;
}> = ({ tiers, selectedPrice, onSelect }) =>
  tiers.length === 1 ? (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
        {tierChoiceLabel(tiers[0])}
      </span>
      <p className="text-xs text-gray-500 dark:text-gray-400">{HINT}</p>
    </div>
  ) : (
    <fieldset className="flex flex-col gap-2">
      <legend className="mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
        Chọn mức phát
      </legend>
      {tiers.map((t) => (
        <label
          key={t.price}
          className="flex cursor-pointer select-none items-center gap-2 text-sm text-gray-700 dark:text-gray-300"
        >
          <input
            type="radio"
            name="music-tier"
            className="accent-blue-600"
            checked={selectedPrice === t.price}
            onChange={() => onSelect(t.price)}
          />
          {tierChoiceLabel(t)}
        </label>
      ))}
      <p className="text-xs text-gray-500 dark:text-gray-400">{HINT}</p>
    </fieldset>
  );

export default MusicTierPicker;
